export const getContacts = (state) => state.contacts
export const getInvoices = (state) => state.invoices
export const getSuppliers = (state) => state.suppliers
export const getPurchaseOrders = (state) => state.purchaseOrders
export const getLoadedData = (state) => state.isDataLoaded

export const invoiceGroupCount = (state) => state.invoiceGroupCount